<template>
  <div class='tour'>
    <!-- <img src='@/assets/nmLogoTekst2.png'> --><br />
    <h1 class='daytour'>Canyon, old forest & cheese</h1>
    <div class='tourPic'>
      <img src='@/assets/daytours/tour3/01.jpg' />
    </div>

    <div>
      <ul class='fa-ul'>
        <li>
          <!-- <span class='fa-li'><i class='fas fa-tree fa-2x'></i></span>  -->
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDescription'
            ><h4 class='titles'>Tour description</h4></a
          >
          <div class='collapse' id='tourDescription'>
            <p class='pasus'>
              This tour is designed as close to the concept of slow travel,
              providing enough time for a relaxed meeting with natural beauties,
              local culinary skills but also cultural heritage.
            </p>
            <p class='pasus'>
              The tour encompasses going through the spectacular 1000 meters
              deep Moraca canyon with its dramatic vertical cliffs and clear
              water flowing in different shades of green, Biogradska Gora
              national park with its glacial lake gem and centuries old
              untouched forest, one of the three of such kind which have
              remained in Europe. Our plan is to take a slow walk around the
              lake (3 km long path) and have a closer look at flora, fauna and
              some elements of cultural heritage of this area. A walk through
              the high beech forest is ideal for deep breeding, mediation and
              Zen moments. It is likely that we will come across some of the
              numerous species of mushrooms and characteristic samples of flora
              too. It is also possible to rent a canoe and take a cruise on the
              lake.
            </p>
            <p class='pasus'>
              After a long, slow and calming walk we will taste a special kind
              of cheese for this region, the famous Kolasin leafy cheese, in
              addition to other local specialties introduced and prepared for us
              by one of the well-known local households. It will also be an
              opportunity for you to get to know the way of life in Montenegrin
              village with all its challenges and charms and have a chat with
              our hosts.
            </p>
            <p class='pasus'>
              Before we head to real Montenegrin heights we won’t miss a chance
              to visit one of the three most famous Montenegrin monasteries –
              Moraca Monastery, the story of which will deepen your
              understanding about Montenegro’s society many centuries of
              existence and challenges that had shaped it.
            </p>
            <p class='pasus'>We are in Podgorica again in the sunset.</p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDetails'
            ><h4 class='titles'>Tour details</h4></a
          >
          <div class='collapse' id='tourDetails'>
            <p class='pasus'>Type of tour: Private</p>
            <p class='pasus'>Availability: May – October</p>
            <p class='pasus'>Group size: 1-7</p>
            <p class='pasus'>Departure from: Podgorica</p>
            <p class='pasus'>Difficulty level: easy</p>
            <p class='pasus'>Duration: 11 h</p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <h4 class='titles'>Highlights</h4>
          <vue-picture-swipe :items='items'></vue-picture-swipe>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#itinerary'
            ><h4 class='titles'>Itinerary</h4></a
          >
          <div class='collapse' id='itinerary'>
            <ul class='square'>
              <li class='pasus'>
                8.30 a.m. - a pick up at your place of stay or at the place we
                agree upon.
              </li>
              <li class='pasus'>
                After approximately 30 minutes of comfortable drive we arrive at
                the viewpoint in the deepest part of the Moraca river canyon. We
                enjoy looking at the dramatic canyon cliffs and clear water.
              </li>
              <li class='pasus'>
                After another 15 minutes of drive we reach Moraca monastery. We
                get to know the monastery complex and the interior of the main
                church within the complex.
              </li>
              <li class='pasus'>
                We continue slowly driving up the main road to Biogradska Gora
                national park where we arrive at around 11:30 after 60 minutes’
                ride.
              </li>
              <li class='pasus'>
                depending on the agreement, we spend between 2 and 3 hours in
                the park, taking a walk around the lake and/or drinking coffee
                or tea at some nice picnic spot near the lake.
              </li>
              <li class='pasus'>
                With appetite gotten up after a long walk and calmed by mountain
                air, we head towards our local hosts to taste the famous cheese
                and many other local delicacies.
              </li>
              <li class='pasus'>
                It should be 6 p.m. already – time to slowly leave the mountain.
              </li>
              <li class='pasus'>
                It is around 7:30 p.m. and we are back in Podgorica full of
                impressions.
              </li>
            </ul>
             <div class='tour-time'>
              <p> <i class='fas fa-clock'></i> 3.5 hours</p>
              <p> <i class='fas fa-route'></i> 200 km</p>
            </div>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#prices'
            ><h4 class='titles'>Prices:</h4></a
          >
          <div class='collapse' id='prices'>
            <ul class='square'>
              <li class='pasus'>1 person – 210 EUR</li>
              <li class='pasus'>2 persons – 135 EUR p/person</li>
              <li class='pasus'>3 persons – 100 EUR p/person</li>
              <li class='pasus'>4 persons – 90 EUR p/person</li>
              <li class='pasus'>5 persons- 110 EUR p/person</li>
              <li class='pasus'>6- persons – 90 EUR p/person</li>
              <li class='pasus'>7- persons – 80 EUR p/person</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#included'
            ><h4 class='titles'>Included in price:</h4></a
          >
          <div class='collapse' id='included'>
            <ul class='square'>
              <li class='pasus'>Driving by car/van</li>
              <li class='pasus'>Bottle of water</li>
              <li class='pasus'>Coffee or tea by the lake</li>
              <li class='pasus'>National park ticket</li>
              <li class='pasus'>Entrance fee to the monastery</li>
              <li class='pasus'>Lunch in a rural household</li>
              <li class='pasus'>Professional guiding service- English</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#info'
            ><h4 class='titles'>Practical info:</h4></a
          >
          <div class='collapse' id='info'>
            <ul class='square'>
              <li class='pasus'>
                We recommend that you carry with you a jacket, a cap,
                sunglasses, some sweets and footwear adequate to conditions in
                the mountain area.
              </li>
              <li class='pasus'>
                The difference in altitude is 1000 meters. We start at the
                elevation of 50 meters to reach the highest point at 1050
                meters.
              </li>
              <li class='pasus'>
                We recommend buying local specialties – smoked ham and cheese in
                vacuum packing as well as the authentic local souvenirs.
              </li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#optional'
            ><h4 class='titles'>Optional:</h4></a
          >
          <div class='collapse' id='optional'>
            <ul class='square'>
               <li class='pasus'>
                Kolasin city tour (shorter walk down the charming small mountain
                town)
              </li>
              <li class='pasus'>Additional walks during the tour</li>
              <li class='pasus'>
                Itinerary changes as agreed (do not affect the price)
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import VuePictureSwipe from 'vue-picture-swipe';
export default {
  data () {
    return {
      items: [
        {
          src: require('@/assets/daytours/tour3/01.jpg'),
          thumbnail: require('@/assets/daytours/tour3/01.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour3/02.jpg'),
          thumbnail: require('@/assets/daytours/tour3/02.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour3/03.jpg'),
          thumbnail: require('@/assets/daytours/tour3/03.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour3/04.jpg'),
          thumbnail: require('@/assets/daytours/tour3/04.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour3/05.jpg'),
          thumbnail: require('@/assets/daytours/tour3/05.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour3/06.jpg'),
          thumbnail: require('@/assets/daytours/tour3/06.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour3/07.jpg'),
          thumbnail: require('@/assets/daytours/tour3/07.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour3/08.jpg'),
          thumbnail: require('@/assets/daytours/tour3/08.jpg'),
          w: 0,
          h: 720
        }
      ]
    }
  }
}
</script>

<style scoped>
h1 {
  background-color: rgba(113, 186, 107, 0.9);
  border-radius: 3px;
  padding: 5px;
}
ul.square {
  list-style-type: square;
  text-align: left;
}
ul.none {
  list-style-type: none;
  text-align: left;
}

.tourPic {
  margin-top: 5vh;
  width: 100%;
}
.tourPic img {
  width: 100%;
}
.tour {
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 15vh;
}
.pasus {
  text-align: justify;
  color: rgb(43, 42, 42);
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/DT3_CanyonForestCheese.vue